module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui middle aligned center aligned grid loadmore"
  }, [_c('div', {
    staticClass: "column padzero"
  }, [_c('div', {
    staticClass: "ui pointing below medium label",
    class: {
      'grey': _vm.isBusy, 'green': !_vm.isError && !_vm.isBusy, 'red': _vm.isError
    }
  }, [_c('i', {
    staticClass: "icon",
    class: {
      'hourglass half': _vm.isBusy, 'file text outline': !_vm.isError && !_vm.isBusy, 'warning sign': _vm.isError && !_vm.isBusy
    }
  }), _vm._v(" "), (_vm.isBusy) ? _c('div', [_vm._v("Loading ...     ")]) : _vm._e(), _vm._v(" "), (!_vm.isError && !_vm.isBusy) ? _c('div', [_vm._v("Showing " + _vm._s(_vm.count) + " of " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.type))]) : _vm._e(), _vm._v(" "), (_vm.isError && !_vm.isBusy) ? _c('div', [_vm._v("Server or network error")]) : _vm._e(), _vm._v(" "), (_vm.isError && !_vm.isBusy) ? _c('a', {
    staticClass: "detail",
    on: {
      "click": function($event) {
        _vm.onRetry()
      }
    }
  }, [_vm._v("Retry")]) : _vm._e(), _vm._v(" "), (_vm.count < _vm.totalCount && !_vm.isError && !_vm.isBusy) ? _c('a', {
    staticClass: "detail",
    on: {
      "click": function($event) {
        _vm.onViewMore()
      }
    }
  }, [_vm._v("View More")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui centered inline loader",
    class: {
      'active': _vm.isBusy
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07e0e861!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loadmore.vue
// module id = 427
// module chunks = 28